import { AnimatedCircularProgressBar } from '@talentmesh/ui/components/animated-circular-progress-bar';
import { TypographyH4 } from '@talentmesh/ui/components/typography';
import PersonalityCharacteristicsPanel from './Characteristics/PersonalityCharacteristicsPanel';
import { Factor } from '@/Models/Factor';

export interface FactorPanelProps {
    factor: Factor;
}

function FactorPanel({ factor }: FactorPanelProps) {
    const { percentileLevel, percentileScore, factorName, characteristics } = factor;

    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-row items-center justify-start gap-4">
                <AnimatedCircularProgressBar
                    value={percentileScore}
                    level={percentileLevel}
                    className="size-12 text-base font-semibold"
                />
                <TypographyH4 className="text-foreground text-base">{factorName}</TypographyH4>
            </div>
            <PersonalityCharacteristicsPanel characteristics={characteristics} />
        </div>
    );
}

export default FactorPanel;
